import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@recruitee/i18n';
import {
  AvatarComponent,
  FormControlTouchStatusPatchDirective,
  IconButtonComponent,
  IconComponent,
  InteractionEventDirective,
  TruncateComponent,
} from '@recruitee/user-interface';

import { AvatarUploadComponent } from './components/avatar-upload/avatar-upload.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { CollapseComponent } from './components/collapse/collapse.component';

const components = [CollapseComponent, BreadcrumbsComponent, AvatarUploadComponent];

@NgModule({
  declarations: components,
  imports: [
    AvatarComponent,
    CommonModule,
    FormControlTouchStatusPatchDirective,
    IconButtonComponent,
    IconComponent,
    RouterModule,
    TruncateComponent,
    TranslatePipe,
    InteractionEventDirective,
  ],
  exports: components,
})
export class SharedModule {}
